/**
 * Photo sharing service is used for sharing photo exchanges between editor and server.
 */
fx.service( class PhotoSharingService extends fx.EventDispatcher {

    constructor(model)
    {
        super();
        this.model = model.creationModel;

        this._isSharingStarted = false;
        this._lastValidatedPhoto = null;
        this.sharedPhotos = [];
        this.currentSharedPhotos = null;
        this.channel = fx.service("Channel");
        this.channel.on("new-photos", this._loadSharedPhotos.bind(this));
    }  

    start(){
        if(this.model.creation.shared)
            this.channel.activate();
    }

    stop(){
        this.channel.deactivate();
    }

    _loadSharedPhotos(data){

        data = data.detail;
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                let photos = [];
                for (let j = 0; j < data[i].photos.length; j++){
                    photos.push(new models.Photo(data[i].photos[j]));
                }
                data[i].photos = photos;
                this.model.photos.addItem(data[i].photos, true);
                this.sharedPhotos.add(data[i]);
            }
            if (!this._isSharingStarted) {
                this._isSharingStarted = true;
                this._loadNextPhotos();
            }
        }
    }

    // validate selected photos and refuse the others
    validate()
    {
        let photos = this.currentSharedPhotos.photos;
        let selectedPhotos = [];
        let unselectedPhotos = [];
        // split photos into two lists : selected and unselected photos
        for(var i = 0; i < photos.length; i++)
        {			
            let photo = photos.getItemAt(i);
            if(photo.selected)
                selectedPhotos.push(photo);
            else
                unselectedPhotos.push(photo);
        }
        // process the two lists (accept selected photos and refuse unselected)
        this._accept(selectedPhotos);
        this._refuse(unselectedPhotos);
        // send validated photos ids to server
        this.channel.send({validated: [this.currentSharedPhotos.id]});
        // process next photos batch, else end the process if no photos remaining
        this.sharedPhotos.removeAt(0);
        if(this.sharedPhotos.length>0)
            this.delay(this._loadNextPhotos,500);
        else
            this._end();
    }

    // refuse all photos and remove them from sharedPhotos list
    reject()
    {
        this._refuse(this.currentSharedPhotos.photos);
        this.sharedPhotos.removeAt(0);
        if(this.sharedPhotos.length>0)
            this.delay(this._loadNextPhotos,500);
        else
            this._end();
    }

    // refuse photos
    _refuse(photos)
    {
        for(var i = 0; i < photos.length; i++)
        {			
            let photo = this.model.photos.find({id: photos.getItemAt(i).id});
            if(photo)
                photo.delete();
        }
    }

    // accept photos
    _accept(photos)
    {
        let photosList = [];
        for(var i = 0; i < photos.length; i++)
        {			
            let photo = this.model.photos.find({id: photos.getItemAt(i).id});
            if(photo)
            {
                photo.validated = 1;
                photosList.add(photo);
            }
        }
        this._lastValidatedPhoto = photosList.getItemAt(0);
        this.delay(this._redirectToPhotopanel, 500);
    }

    // if several photos batches have been received from the channel, process next batch
    _loadNextPhotos()
    {
        this.currentSharedPhotos = this.sharedPhotos.getItemAt(0);
        this.model.event("share-upload-started");
    }

    // if no photos batches remaining, stop receiving popups
    _end()
    {
        this.currentSharedPhotos = null;
        if(window.fx.browser.isMobile && (this._lastValidatedPhoto != null))
            this.delay(this._redirectToPhotopanel, 500);
        else
            this.model.event("show-editor");

        this._isSharingStarted = false;
    }

    _redirectToPhotopanel()
    {
        this.model.event("switch-photoPanel");  
        this.model.creation.event("share-upload-validated", {photo: this._lastValidatedPhoto}, 1000);
    }

});

